import { getTodayInTimeZone } from '@/utils/date-time-helper';

export const ensureAbsoluteUrl = (url: string | undefined): string | undefined => {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (trimmed.startsWith('/')) return trimmed;
  return `https://${trimmed}`;
};

export const buildUrlWithParams = (url: string, params: Record<string, unknown>): string => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[key] = String(value);
      }
      return acc;
    }, {} as Record<string, string>)
  ).toString();

  return queryString ? `${url}?${queryString}` : url;
};

export const buildMovieUrlWithDate = (baseUrl: string, selectedDate?: Date, timeZone?: string): string => {
  if (!selectedDate) return baseUrl;

  const resolvedDate = timeZone ? getTodayInTimeZone(timeZone, selectedDate) : selectedDate;
  const year = resolvedDate.getFullYear();
  const month = String(resolvedDate.getMonth() + 1).padStart(2, '0');
  const day = String(resolvedDate.getDate()).padStart(2, '0');
  const dateStr = `${year}-${month}-${day}`;
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}showDate=${dateStr}`;
};
